import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { FC, useCallback } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { TRANSLATION_KEYS as tr } from '../../../translations'

import { KeyInitiativeEditorContent } from './components/keyInitiativeEditorContent/KeyInitiativeEditorContent'
import { IKeyInitiativeEditorContentProps } from './models/IKeyInitiativeEditorContentProps'

import styles from './KeyInitiativeEditorModal.module.scss'

interface IKeyInitiativeEditorModalProps extends IKeyInitiativeEditorContentProps {
  isOpen: boolean
  keyInitiativesFormat: number
  setKeyInitiativesFormat: (newValue: number) => void
}

export const KeyInitiativeEditorModal: FC<IKeyInitiativeEditorModalProps> = ({
  initialData,
  partnerId,
  programType,
  onApply,
  isCommercial,
  isDataInsightPresent,
  isDataInsightTab,
  isAmplifyImpactInfoSection,
  onCancel,
  saveAsNew,
  keyObjectivesFilter,
  pendingKeyInitiative,
  finSobData,

  isOpen,
  keyInitiativesFormat,
  setKeyInitiativesFormat,

  fYear,
  businessPriorities,
  keyObjectives,
  keyObjectiveTags,
  initiativeFormKey,
  parentFormKey,
}) => {
  const modalHeader = useCallback(() => {
    return (
      <div className={styles.title}>
        <WidgetHeader>{tr.keyInitiativeEditor.keyInitiativeTitle}</WidgetHeader>
      </div>
    )
  }, [])

  if (!isOpen) {
    return null
  }

  return (
    <ModalDialog
      show={isOpen}
      onClose={onCancel}
      classes={{
        overlay: styles.modalOverlay,
        window: styles.modalWindow,
        body: styles.modalBody,
      }}
      header={modalHeader}
      closeOnOutsideClick={false}
      content={KeyInitiativeEditorContent}
      size="sm"
      contentProps={{
        keyInitiativesFormat,
        setKeyInitiativesFormat,
        keyObjectivesFilter,
        isDataInsightPresent,
        isDataInsightTab,
        isAmplifyImpactInfoSection,
        isCommercial,
        partnerId,
        initialData,
        programType,
        onApply,
        onCancel,
        saveAsNew,
        pendingKeyInitiative,
        finSobData,
        fYear,
        businessPriorities,
        keyObjectives,
        keyObjectiveTags,
        initiativeFormKey,
        parentFormKey,
      }}
    />
  )
}
